import {GET_FORM_VENDOR_COMPANY} from 'shared/constants/ActionTypes';

const initialState = {
  form: {
    address: '',
    banlTransportLimit: '',
    billingAccountNo: '',
    customerTransportLimit: '',
    differenceAccountNo: '',
    district: '',
    fine: '',
    id: '',
    insurance: '',
    limitCashInvault: '',
    name: '',
    officePhone1: '',
    officePhone2: '',
    picEmail1: '',
    picMobilePhone1: '',
    picName1: '',
    picEmail2: '',
    picMobilePhone2: '',
    picName2: '',
    postalCode: '',
    province: '',
    rating: '',
    status: '',
    subDistrict: '',
    urbanVillage: '',
  },
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_FORM_VENDOR_COMPANY:
      return {
        ...state,
        form: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
